import * as CubeTree from '../cubeTree/index';
import Drag from './drag';
import { __add__, __has__ } from './db';

export function add(cubeId: CubeId): void {
    let dragInstance: DragCubeNode = new Drag({
        cubeId
    });

    __add__(cubeId, dragInstance);
}

export function addDeep(cubeId: CubeId): void {
    if (__has__(cubeId)) {
        return;
    }

    let cubeIds: Array<CubeId> = CubeTree.findAllChildrenContainSelf(cubeId);

    cubeIds.forEach((cubeId: CubeId): void => {
        if (CubeTree.isSketchpad(cubeId)
            || CubeTree.isCabinet(cubeId)) {
            return;
        }
        add(cubeId);
    });
}
